export const ChartPeriod = {
  '1w': '1w',
  '1m': '1m',
  '1y': '1y',
  all: 'all',
} as const;

export type ChartPeriodType = keyof typeof ChartPeriod;
